import { ExtratoPrevicenciaRepository } from '../../repositories/extrato_previdencia.repository';
import { apiSensedia } from '../api-sensedia';
import { db } from '../db';
import { ExtratoCarteiraPrevidencia } from './../db';

type ExtratoServiceParams = {
  ev: number;
  cpf: string;
  proposta: string;
};
type ExtratoDownloadRequest = {
  data_inicial: string;
  data_final: string;
};
export function ExtratoService(
  extratoRepository: ExtratoPrevicenciaRepository,
  params: ExtratoServiceParams
) {
  async function getPDFLinks(body: ExtratoDownloadRequest[]) {
    const saved = await extratoRepository.getExtratosByCPFAndProposta({
      cpf: params.cpf,
      proposta: params.proposta
    });
    console.log({ body });

    return Promise.all(
      body.map(async (item) => {
        const foundSaved = saved.find(
          (savedItem) =>
            savedItem.data_inicial === item.data_inicial &&
            savedItem.data_final === item.data_final
        );
        if (!foundSaved) {
          const url = await getSignedURL(item);
          console.log({ url });
          const expirationTime = new URL(url).searchParams.get('Expires');
          extratoRepository.add({
            ev: params.ev,
            cpf: params.cpf,
            proposta: params.proposta,
            data_inicial: item.data_inicial,
            data_final: item.data_final,
            pdf_url: url,
            pdf_date_expiration: Number(expirationTime)
          });
          return url;
        }
        const isLinkExpired =
          new Date(foundSaved.pdf_date_expiration * 1000) < new Date();

        if (foundSaved && !isLinkExpired) {
          return foundSaved.pdf_url;
        } else {
          const url = await getSignedURL(item);
          const expirationTime = new URL(url).searchParams.get('Expires');
          extratoRepository.updateExtrato(
            Number(foundSaved.id),
            url,
            Number(expirationTime)
          );
          return url;
        }
      })
    );
  }

  async function getSignedURL(data: ExtratoDownloadRequest) {
    const queryParams = {
      cpf: String(params.cpf),
      proposta: String(params.proposta),
      data_inicial: String(data.data_inicial),
      data_final: String(data.data_final)
    };
    const { data: url } = await apiSensedia.get(
      `/gestao-de-carteiras/carteira-previdencia-individual/extrato`,
      { params: queryParams }
    );

    return String(url);
  }

  return {
    getPDFLinks
  };
}

////return an array of string of pdfs
//export const getPdfs = async (data: any[]) => {
//  const saved = await db.extratoCarteira
//    .where({ ev: data[0].ev, proposta: data[0].proposta })
//    .toArray();

//    /* downloadPDF({
//      cpf: item.cpf,
//      proposta: item.proposta,
//      data_inicial: item.data_inicial,
//      data_final: item.data_final
//    }) */
//};

//type ExtratoDownloadRequest = {
//  cpf: string;
//  proposta: string;
//  data_inicial: string;
//  data_final: string;
//};
//const downloadPDF = async (data: ExtratoDownloadRequest) => {
//  const queryParams = {
//    cpf: String(data.cpf),
//    proposta: String(data.proposta),
//    data_inicial: String(data.data_inicial),
//    data_final: String(data.data_final)
//  };
//  const {
//    data: { url }
//  } = await apiSensedia.get(
//    `/gestao-de-carteiras/carteira-previdencia-individual/extrato`,
//    { params: queryParams }
//  );

//  console.log({ url });
//  //download pdf from googleapis with response.data.url

//  return String(url);
//};
